import {getPrivateAxios} from '../../libs';
import {Collection} from './types';

type CollectionCreateDto = Pick<Collection, 'name' | 'description'>;

export const fetchCollectionCreate = async (createDto: CollectionCreateDto) => {
  return getPrivateAxios()
    .post<Collection>('/collections', createDto)
    .then((response) => response.data);
};
